import { Card, Drawer, Radio, Select, DatePicker, message, Switch } from "antd";
import React, { useMemo, useState } from "react";
import moment from "moment";
import useSearchContext from "../../../hooks/useSearchContext";
import {
  PhoneOutlined,
  FilePdfOutlined,
  IdcardOutlined,
  FileWordOutlined,
  CopyOutlined,
  CalendarOutlined,
  DownOutlined,
  FileImageOutlined,
  CheckOutlined,
  UserOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";
import useAxios from "../../../hooks/useAxios";

const { Option } = Select;
const { RangePicker } = DatePicker;

export const handleFilterDateClicks = (type) => {
  if (type === "Last 7 Days") {
    return [
      {
        _i: moment(new Date()).subtract(7, "day").format("YYYY-MM-DD"),
      },
      {
        _i: moment(new Date()).format("YYYY-MM-DD"),
      },
    ];
  }

  if (type === "Last 15 Days") {
    return [
      {
        _i: moment(new Date()).subtract(15, "day").format("YYYY-MM-DD"),
      },
      {
        _i: moment(new Date()).format("YYYY-MM-DD"),
      },
    ];
  }
  if (type === "Last 30 Days") {
    return [
      {
        _i: moment(new Date()).subtract(1, "month").format("YYYY-MM-DD"),
      },
      {
        _i: moment(new Date()).format("YYYY-MM-DD"),
      },
    ];
  }

  if (type === "Last 3 Months") {
    return [
      {
        _i: moment(new Date()).subtract(3, "month").format("YYYY-MM-DD"),
      },
      {
        _i: moment(new Date()).format("YYYY-MM-DD"),
      },
    ];
  }

  if (type === "Today") {
    return [
      {
        _i: moment(new Date()).format("YYYY-MM-DD"),
      },
      {
        _i: moment(new Date()).format("YYYY-MM-DD"),
      },
    ];
  }

  return [];
};

const candidateTypes = [
  { label: "Agent", key: "Agent" },
  { label: "Non Agent", key: "Non-Agent" },
  { label: "GIG", key: "GIG" },
];

const AdvanceFilters = ({
  setAdvanceFilter,
  advanceFilter,
  loadCandidates,
  allTrfs,
  users,
  allSources,
  allQualification,
  callMasters,
  interviewRouds,
  allPositions,
  isAppliedFilterEnable,
  statusParameters,
  locations,
  formNames,
  clearFilters,
  setLoad,
  allJobTypes,
  designations,
  departments,
  mapping,
  isAmeyoActive,
}) => {
  const api = useAxios();
  const {
    trfId,
    setTrfId,
    interviewStatus,
    setInterviewStatus,
    headerFilterStatus,
    source,
    setSource,
    setQualification,
    qualification,
    callMasterId,
    setCallMasterId,
    recruiter,
    setRecruiter,
    positions,
    setPositions,
    setAdvanceappliedFilters,
    versantScore,
    setVersantScore,
    setLocation,
    location,
    setFormId,
    formId,
    selectedDatevalue,
    setSelectedDatevalue,
    setDefaultDate,
    modeOfInterview,
    setModeOfInterview,
    rotationalShift,
    setRotationalShift,
    interested,
    defaultDate,
    setInterested,
    setTsNavigateFromTrf,
    isNavigateFromTrf,
    jobType,
    setJobType,
    candidateType,
    setCandidateType,
    departmentId,
    setDepartmentId,
    designationId,
    setDesignationId,
    whatsAppCampaign,
    setWhatsAppCampaign,
    whatsAppResponse,
    setWhatsAppResponse,
    setHirePage,
    setHoldPage,
    setRejectPage,
    setPoolPage,
    setCurrent,
    callType,
    setCallType,
  } = useSearchContext();

  const [startDate, setStartDate] = useState();

  const handleDate = (value, dateString) => {
    setSelectedDatevalue("Custom");
    if (value === null) {
      setDefaultDate([
        moment(new Date()).format("YYYY-MM-DD"),
        moment(new Date()).format("YYYY-MM-DD"),
      ]);
    } else {
      let startDate = moment(dateString[0], "YYYY-MM-DD");
      let endDate = moment(dateString[1], "YYYY-MM-DD");
      setDefaultDate([startDate, endDate]);
    }
  };

  function disableFutureDates(current) {
    const maxDate = startDate
      ? moment(startDate).add(12, "month")
      : moment().endOf("day");
    return current && (current > moment().endOf("day") || current > maxDate);
  }

  const handleCalendarChange = (dates) => {
    if (dates && dates[0]) {
      setStartDate(dates[0]);
    }
  };

  const viewData = async () => {
    const activeFilters = [
      interviewStatus,
      modeOfInterview,
      trfId,
      callMasterId,
      whatsAppCampaign,
      whatsAppResponse,
      designationId.length !== 0,
      departmentId.length !== 0,
      formId.length !== 0,
      location.length !== 0,
      interested.length !== 0,
      rotationalShift.length !== 0,
      qualification.length !== 0,
      recruiter.length !== 0,
      source.length !== 0,
      positions.length !== 0,
      versantScore.length !== 0,
      jobType.length !== 0,
      candidateType.length !== 0,
      callType.length !== 0,
    ].filter(Boolean).length;
    setAdvanceappliedFilters(activeFilters);
    await loadCandidates();
    setAdvanceFilter(false);
  };

  const clearPage = () => {
    setCurrent(1);
    setHirePage(1);
    setHoldPage(1);
    setRejectPage(1);
    setPoolPage(1);
  };

  const saveFilter = async () => {
    try {
      const payload = {
        userId: [localStorage.getItem("user.id")],
        duration: [selectedDatevalue],
        modeOfInterview: [modeOfInterview],
        callStatus: [callMasterId],
        trf: [trfId],
        whatsAppCampaign: [whatsAppCampaign],
        whatsAppResponse: [whatsAppResponse],
        designationId: [...designationId],
        departmentId: [...departmentId],
        source: [...source],
        applicationType: [...formId],
        location: [...location],
        position: [...positions],
        recruiter: [...recruiter],
        versant: [...versantScore],
        qualification: [...qualification],
        interested: [...interested],
        rotationalShift: [...rotationalShift],
        jobType: [...jobType],
        candidateType: [...candidateType],
      };
      setLoad(true);
      const { data } = await api.post(`/candidateFilters`, payload, {
        tokenType: "user",
      });
      if (data) {
        message.success("Filters saved successfully.");
      }
    } catch (err) {
      console.error(err);
      message.error("Something went wrong.");
    } finally {
      setLoad(false);
    }
  };

  const isApplicationReceived = headerFilterStatus === "Application_Received";
  const filtered = Array.isArray(formId)
    ? formId.filter((e) => e !== true)
    : [];

  const filteredDesignations = useMemo(() => {
    if (!departmentId?.length) return designations;

    return designations.filter((d) =>
      mapping.some(
        (m) =>
          departmentId.includes(m.departmentId?._id) &&
          m.designationId?._id === d._id,
      ),
    );
  }, [designations, departmentId, mapping]);

  const filteredDepartments = useMemo(() => {
    if (!designationId?.length) return departments;

    return departments.filter((dept) =>
      mapping.some(
        (m) =>
          designationId.includes(m.designationId?._id) &&
          m.departmentId?._id === dept._id,
      ),
    );
  }, [designationId, departments, mapping]);

  return (
    <Drawer
      title="Filters"
      width={720}
      placement="right"
      onClose={() => setAdvanceFilter(!advanceFilter)}
      open={advanceFilter}
    >
      <div className="d-flex flex-column gap-3" style={{ height: "100%" }}>
        <div className="row" style={{ flex: 1 }}>
          <div className="col-12">
            <div className="row">
              <div className="col-12">
                <div className="w-100 d-flex flex-column gap-1">
                  <div>
                    <label>Duration</label>
                    <div
                      className="d-flex flex-column"
                      style={{ gap: "0.5rem" }}
                    >
                      <Radio.Group
                        buttonStyle="solid"
                        style={{
                          width: "100%",
                          marginBottom: 5,
                          display: "flex",
                          gap: "5px",
                        }}
                        value={selectedDatevalue}
                        onChange={(e) => {
                          clearPage();
                          if (isNavigateFromTrf) {
                            setTsNavigateFromTrf(false);
                            setSelectedDatevalue("Last 30 Days");
                            setDefaultDate(
                              handleFilterDateClicks("Last 30 Days"),
                            );
                          }
                          setSelectedDatevalue(e.target.value);
                          setDefaultDate(
                            handleFilterDateClicks(e.target.value),
                          );
                        }}
                      >
                        <Radio.Button
                          className="flex-fill text-center"
                          value="Today"
                        >
                          Today
                        </Radio.Button>
                        <Radio.Button
                          className="flex-fill text-center"
                          value="Last 7 Days"
                        >
                          7 days
                        </Radio.Button>
                        <Radio.Button
                          className="flex-fill text-center"
                          value="Last 15 Days"
                        >
                          15 days
                        </Radio.Button>
                        <Radio.Button
                          className="flex-fill text-center"
                          value="Last 30 Days"
                        >
                          30 days
                        </Radio.Button>
                        <Radio.Button
                          className="flex-fill text-center"
                          value="Last 3 Months"
                        >
                          3 months
                        </Radio.Button>
                        <Radio.Button
                          className="flex-fill text-center"
                          value="Custom"
                        >
                          Custom
                        </Radio.Button>
                      </Radio.Group>
                      {selectedDatevalue === "Custom" && (
                        <div className="d-flex flex-column align-items-start">
                          <label>Date Range</label>
                          <RangePicker
                            format="YYYY-MM-DD"
                            onChange={handleDate}
                            value={[
                              defaultDate[0]
                                ? moment(defaultDate[0]?._i)
                                : null,
                              defaultDate[1]
                                ? moment(defaultDate[1]?._i)
                                : null,
                            ]}
                            onCalendarChange={handleCalendarChange}
                            disabledDate={disableFutureDates}
                            disabled={selectedDatevalue !== "Custom"}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  {headerFilterStatus !== "Application_Received" && (
                    <div>
                      <label>Mode of Interview</label>
                      <div
                        className="d-flex flex-column"
                        style={{ gap: "0.5rem" }}
                      >
                        <Radio.Group
                          buttonStyle="solid"
                          style={{
                            width: "100%",
                            marginBottom: 5,
                            display: "flex",
                            gap: "5px",
                          }}
                          value={modeOfInterview}
                          onChange={(e) => {
                            clearPage();

                            if (isNavigateFromTrf) {
                              setTsNavigateFromTrf(false);
                              setSelectedDatevalue("Last 30 Days");
                              setDefaultDate(
                                handleFilterDateClicks("Last 30 Days"),
                              );
                            }
                            setModeOfInterview(e.target.value);
                          }}
                        >
                          <Radio.Button
                            className="flex-fill d-flex align-items-center justify-content-center"
                            value=""
                            style={{ height: "65px" }}
                          >
                            <div className="mt-2 d-flex flex-column align-items-center justify-content-center">
                              <CheckOutlined style={{ fontSize: "1.2rem" }} />
                              <div>Any</div>
                            </div>
                          </Radio.Button>
                          <Radio.Button
                            className="flex-fill d-flex align-items-center justify-content-center"
                            value="Telephonic"
                            style={{ height: "65px" }}
                          >
                            <div className="mt-2 d-flex flex-column align-items-center justify-content-center">
                              <PhoneOutlined style={{ fontSize: "1.2rem" }} />
                              <div>Telephonic</div>
                            </div>
                          </Radio.Button>
                          <Radio.Button
                            className="flex-fill d-flex align-items-center justify-content-center"
                            value="Video Call"
                            style={{ height: "65px" }}
                          >
                            <div className="mt-2 d-flex flex-column align-items-center justify-content-center">
                              <VideoCameraOutlined
                                style={{ fontSize: "1.2rem" }}
                              />
                              <div>Video Call</div>
                            </div>
                          </Radio.Button>
                          <Radio.Button
                            className="flex-fill d-flex align-items-center justify-content-center"
                            value="In Person"
                            style={{ height: "65px" }}
                          >
                            <div className="mt-2 d-flex flex-column align-items-center justify-content-center">
                              <UserOutlined style={{ fontSize: "1.2rem" }} />
                              <div>In Person</div>
                            </div>
                          </Radio.Button>
                        </Radio.Group>
                      </div>
                    </div>
                  )}
                  <div className="row">
                    <div className="col-md-6 mb-2">
                      {/* <div className="flex justify-between"> */}
                      <label>Application Type</label>
                      {/* {headerFilterStatus === "Application_Received" && (
                          <Switch
                            onChange={(e) => {
                              setUnassigned(e);
                            }}
                            style={{
                              backgroundColor: unassigned ? "#254568" : "",
                            }}
                            checkedChildren="Unassigned"
                            unCheckedChildren="Unassigned"
                            checked={unassigned}
                          />
                        )}
                      </div> */}
                      <div>
                        <Select
                          showSearch
                          mode="multiple"
                          getPopupContainer={(triggerNode) =>
                            triggerNode.parentElement
                          }
                          value={
                            formId
                              ? isApplicationReceived
                                ? formId
                                  ? formId
                                  : []
                                : filtered
                              : []
                          }
                          className="w-100 p-0 outline-none bg-white increase_drop"
                          placeholder="Application Type"
                          optionFilterProp="children"
                          filterOption={(input, option) => {
                            const search = input.toLowerCase();
                            return (
                              String(option?.children ?? "")
                                .toLowerCase()
                                .includes(search) ||
                              String(option?.value ?? "")
                                .toLowerCase()
                                .includes(search)
                            );
                          }}
                          onChange={(value) => {
                            clearPage();

                            if (isNavigateFromTrf) {
                              setTsNavigateFromTrf(false);
                              setSelectedDatevalue("Last 30 Days");
                              setDefaultDate(
                                handleFilterDateClicks("Last 30 Days"),
                              );
                            }
                            setFormId([...value]);
                          }}
                        >
                          {[
                            ...formNames,
                            isApplicationReceived
                              ? {
                                  _id: true,
                                  name: "Unassigned",
                                  formType: "Joining_Form",
                                }
                              : {},
                          ]
                            ?.sort((a, b) =>
                              a.name
                                ?.trim()
                                .toLowerCase()
                                .localeCompare(b.name?.trim().toLowerCase()),
                            )
                            ?.map((form) => {
                              if (
                                form.formType &&
                                form.formType === "Joining_Form"
                              ) {
                                return (
                                  <Option key={form?._id} value={form?._id}>
                                    {form?.name?.trim()}
                                  </Option>
                                );
                              }
                            })}
                        </Select>
                      </div>
                    </div>
                    <div className="col-md-6 mb-2">
                      <label>User Type</label>
                      <div>
                        <Select
                          showSearch
                          mode="multiple"
                          getPopupContainer={(triggerNode) =>
                            triggerNode.parentElement
                          }
                          className="filter-group-select w-100 p-0 outline-none bg-white cutom_select_advance"
                          placeholder="Select User Type"
                          value={candidateType || null}
                          optionFilterProp="children"
                          filterOption={(input, option) => {
                            return (
                              option?.children
                                ?.toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0 ||
                              option.value
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            );
                          }}
                          onChange={(value) => {
                            clearPage();

                            if (isNavigateFromTrf) {
                              setTsNavigateFromTrf(false);
                              setSelectedDatevalue("Last 30 Days");
                              setDefaultDate(
                                handleFilterDateClicks("Last 30 Days"),
                              );
                            }
                            setCandidateType([...value]);
                          }}
                        >
                          {candidateTypes
                            ?.sort((a, b) =>
                              a?.label
                                ?.trim()
                                .toLowerCase()
                                .localeCompare(b?.label?.trim().toLowerCase()),
                            )
                            ?.map((candidateType, index) => {
                              return (
                                <Option key={index} value={candidateType?.key}>
                                  {candidateType?.label}
                                </Option>
                              );
                            })}
                        </Select>
                      </div>
                    </div>
                    <div className="col-md-6 mb-2">
                      <label>Select Department</label>
                      <div>
                        <Select
                          showSearch
                          mode="multiple"
                          getPopupContainer={(triggerNode) =>
                            triggerNode.parentElement
                          }
                          className="filter-group-select w-100 p-0 outline-none bg-white cutom_select_advance"
                          optionFilterProp="children"
                          filterOption={(input, option) => {
                            return (
                              String(option?.children ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase()) ||
                              String(option?.value ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            );
                          }}
                          placeholder="Select Department"
                          style={{ width: 300 }}
                          value={departmentId || null}
                          onChange={(value) => {
                            if (isNavigateFromTrf) {
                              setTsNavigateFromTrf(false);
                              setSelectedDatevalue("Last 30 Days");
                              setDefaultDate(
                                handleFilterDateClicks("Last 30 Days"),
                              );
                            }
                            setDepartmentId([...value]);
                          }}
                        >
                          {filteredDepartments?.map((department) => {
                            return (
                              <Select.Option key={department?._id} value={department?._id}>
                                {department?.department ||
                                  department?.departmentName}
                              </Select.Option>
                            );
                          })}
                        </Select>
                      </div>
                    </div>
                    <div className="col-md-6 mb-2">
                      <label>Select Designation</label>
                      <div>
                        <Select
                          showSearch
                          mode="multiple"
                          getPopupContainer={(triggerNode) =>
                            triggerNode.parentElement
                          }
                          className="filter-group-select w-100 p-0 outline-none bg-white cutom_select_advance"
                          optionFilterProp="children"
                          filterOption={(input, option) => {
                            return (
                              String(option?.children ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase()) ||
                              String(option?.value ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            );
                          }}
                          placeholder="Select Designation"
                          style={{ width: 300 }}
                          value={designationId || null}
                          onChange={(value) => {
                            if (isNavigateFromTrf) {
                              setTsNavigateFromTrf(false);
                              setSelectedDatevalue("Last 30 Days");
                              setDefaultDate(
                                handleFilterDateClicks("Last 30 Days"),
                              );
                            }
                            setDesignationId([...value]);
                          }}
                        >
                          {filteredDesignations?.map((designation) => {
                            return (
                              <Select.Option key={designation?._id} value={designation?._id}>
                                {designation?.designation}
                              </Select.Option>
                            );
                          })}
                        </Select>
                      </div>
                    </div>
                    <div className="col-md-6 mb-2">
                      <label>Job Type</label>
                      <div>
                        <Select
                          showSearch
                          mode="multiple"
                          getPopupContainer={(triggerNode) =>
                            triggerNode.parentElement
                          }
                          className="filter-group-select w-100 p-0 outline-none bg-white cutom_select_advance"
                          placeholder="Select Job Type"
                          value={jobType || null}
                          optionFilterProp="children"
                          filterOption={(input, option) => {
                            return (
                              option?.children
                                ?.toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0 ||
                              option.value
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            );
                          }}
                          onChange={(value) => {
                            clearPage();

                            if (isNavigateFromTrf) {
                              setTsNavigateFromTrf(false);
                              setSelectedDatevalue("Last 30 Days");
                              setDefaultDate(
                                handleFilterDateClicks("Last 30 Days"),
                              );
                            }
                            setJobType([...value]);
                          }}
                        >
                          {allJobTypes
                            ?.sort((a, b) =>
                              a?.name
                                ?.trim()
                                .toLowerCase()
                                .localeCompare(b?.name?.trim().toLowerCase()),
                            )
                            ?.map((jobType, index) => {
                              return (
                                <Option key={index} value={jobType?.name}>
                                  {jobType?.name}
                                </Option>
                              );
                            })}
                        </Select>
                      </div>
                    </div>
                    <div className="col-md-6 mb-2">
                      <label>Source</label>
                      <div>
                        <Select
                          showSearch
                          mode="multiple"
                          getPopupContainer={(triggerNode) =>
                            triggerNode.parentElement
                          }
                          className="filter-group-select w-100 p-0 outline-none bg-white cutom_select_advance"
                          placeholder="Select Source"
                          value={source || null}
                          optionFilterProp="children"
                          filterOption={(input, option) => {
                            return (
                              option?.children
                                ?.toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0 ||
                              option.value
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            );
                          }}
                          onChange={(value) => {
                            clearPage();

                            if (isNavigateFromTrf) {
                              setTsNavigateFromTrf(false);
                              setSelectedDatevalue("Last 30 Days");
                              setDefaultDate(
                                handleFilterDateClicks("Last 30 Days"),
                              );
                            }
                            setSource([...value]);
                          }}
                        >
                          {allSources
                            ?.sort((a, b) =>
                              a
                                ?.trim()
                                .toLowerCase()
                                .localeCompare(b?.trim().toLowerCase()),
                            )
                            ?.map((source, index) => {
                              return (
                                <Option key={index} value={source}>
                                  {source}
                                </Option>
                              );
                            })}
                        </Select>
                      </div>
                    </div>
                    <div className="col-md-6 mb-2">
                      <label>Location</label>
                      <div>
                        <Select
                          showSearch
                          mode="multiple"
                          getPopupContainer={(triggerNode) =>
                            triggerNode.parentElement
                          }
                          className="w-100 p-0 outline-none bg-white"
                          placeholder="Location"
                          value={location || null}
                          optionFilterProp="children"
                          filterOption={(input, option) => {
                            return (
                              option?.children
                                ?.toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0 ||
                              option.value
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            );
                          }}
                          onChange={(value) => {
                            clearPage();

                            if (isNavigateFromTrf) {
                              setTsNavigateFromTrf(false);
                              setSelectedDatevalue("Last 30 Days");
                              setDefaultDate(
                                handleFilterDateClicks("Last 30 Days"),
                              );
                            }
                            setLocation([...value]);
                          }}
                        >
                          {locations
                            ?.sort((a, b) =>
                              a.locationName
                                ?.trim()
                                .toLowerCase()
                                .localeCompare(
                                  b.locationName?.trim().toLowerCase(),
                                ),
                            )
                            ?.map((loc) => {
                              if (!loc.status) return;
                              return (
                                <Option
                                  key={loc?._id}
                                  value={loc?.locationName?.trim()}
                                >
                                  {loc?.locationName?.trim()}
                                </Option>
                              );
                            })}
                        </Select>
                      </div>
                    </div>
                    <div className="col-md-6 mb-2">
                      <label>Whatsapp Campaign Trigger</label>
                      <div>
                        <Select
                          showSearch
                          getPopupContainer={(triggerNode) =>
                            triggerNode.parentElement
                          }
                          className="w-100 p-0 outline-none bg-white"
                          placeholder="Whatsapp Campaign Trigger"
                          value={whatsAppCampaign || null}
                          optionFilterProp="children"
                          filterOption={(input, option) => {
                            return (
                              option?.children
                                ?.toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0 ||
                              option.value
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            );
                          }}
                          onChange={(value) => {
                            clearPage();

                            if (isNavigateFromTrf) {
                              setTsNavigateFromTrf(false);
                              setSelectedDatevalue("Last 30 Days");
                              setDefaultDate(
                                handleFilterDateClicks("Last 30 Days"),
                              );
                            }

                            if (value === null) {
                              setWhatsAppCampaign("");
                              return;
                            }

                            if (value === "No" || value === null) {
                              setWhatsAppResponse("");
                            }

                            setWhatsAppCampaign(value);
                          }}
                        >
                          <Option value={null}>All</Option>
                          <Option value={"Yes"}>Yes</Option>
                          <Option value={"No"}>No</Option>
                        </Select>
                      </div>
                    </div>
                    {whatsAppCampaign === "Yes" && (
                      <div className="col-md-6 mb-2">
                        <label>Whatsapp Response</label>
                        <div>
                          <Select
                            showSearch
                            getPopupContainer={(triggerNode) =>
                              triggerNode.parentElement
                            }
                            className="w-100 p-0 outline-none bg-white"
                            placeholder="Whatsapp Response"
                            value={whatsAppResponse || null}
                            optionFilterProp="children"
                            filterOption={(input, option) => {
                              return (
                                option?.children
                                  ?.toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0 ||
                                option.value
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              );
                            }}
                            onChange={(value) => {
                              clearPage();

                              if (isNavigateFromTrf) {
                                setTsNavigateFromTrf(false);
                                setSelectedDatevalue("Last 30 Days");
                                setDefaultDate(
                                  handleFilterDateClicks("Last 30 Days"),
                                );
                              }
                              if (value === null) {
                                setWhatsAppResponse("");
                                return;
                              }
                              setWhatsAppResponse(value);
                            }}
                          >
                            <Option value={null}>All</Option>
                            <Option value={"Responded"}>Responded</Option>
                            <Option value={"Not Responded"}>
                              Not Responded
                            </Option>
                          </Select>
                        </div>
                      </div>
                    )}
                    {/* <div className="col-md-6 mb-2">
                      <label>Position</label>
                      <div>
                        <Select
                          showSearch
                          mode="multiple"
                          className="w-100 p-0 outline-none bg-white"
                          placeholder="Select Position"
                          value={positions || null}
                          optionFilterProp="children"
                          filterOption={(input, option) => {
                            return (
                              option?.children
                                ?.toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0 ||
                              option.value
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            );
                          }}
                          onChange={(value) => {
                            setCurrent(1);
                            if (isNavigateFromTrf) {
                              setTsNavigateFromTrf(false);
                              setSelectedDatevalue("Last 30 Days");
                              setDefaultDate(
                                handleFilterDateClicks("Last 30 Days"),
                              );
                            }
                            setPositions([...value]);
                          }}
                        >
                          <Option value={"Customer Support Executive"}>
                            Customer Support Executive
                          </Option>
                          {allPositions?.map((pos, index) => {
                            return (
                              <Option key={index} value={pos}>
                                {pos}
                              </Option>
                            );
                          })}
                        </Select>
                      </div>
                    </div> */}
                  </div>
                  <div>
                    <label>Call Status</label>
                    <div
                      className="d-flex flex-column"
                      style={{ gap: "0.5rem" }}
                    >
                      <Radio.Group
                        buttonStyle="solid"
                        style={{
                          width: "100%",
                          marginBottom: 5,
                          display: "flex",
                          gap: "5px",
                        }}
                        value={callMasterId}
                        onChange={(e) => {
                          clearPage();

                          if (isNavigateFromTrf) {
                            setTsNavigateFromTrf(false);
                            setSelectedDatevalue("Last 30 Days");
                            setDefaultDate(
                              handleFilterDateClicks("Last 30 Days"),
                            );
                          }
                          setCallMasterId(e.target.value);
                        }}
                      >
                        <Radio.Button
                          className="flex-fill text-center"
                          value={""}
                        >
                          Any
                        </Radio.Button>
                        {callMasters?.map((callStatus) => {
                          return (
                            <Radio.Button
                              key={callStatus?._id || callStatus?.name}
                              className="flex-fill text-center"
                              value={callStatus?.name}
                            >
                              {callStatus?.name}
                            </Radio.Button>
                          );
                        })}
                        <Radio.Button
                          className="flex-fill text-center"
                          value={"Not Attempted"}
                        >
                          Not Attempted
                        </Radio.Button>
                      </Radio.Group>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <label>Interested</label>
                      <div>
                        <Select
                          showSearch
                          mode="multiple"
                          getPopupContainer={(triggerNode) =>
                            triggerNode.parentElement
                          }
                          className="w-100 p-0 outline-none bg-white"
                          placeholder="Select Interested"
                          value={interested || null}
                          optionFilterProp="children"
                          filterOption={(input, option) => {
                            return (
                              option?.children
                                ?.toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0 ||
                              option.value
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            );
                          }}
                          onChange={(value) => {
                            clearPage();

                            if (isNavigateFromTrf) {
                              setTsNavigateFromTrf(false);
                              setSelectedDatevalue("Last 30 Days");
                              setDefaultDate(
                                handleFilterDateClicks("Last 30 Days"),
                              );
                            }
                            setInterested([...value]);
                          }}
                        >
                          <Option value={"Not Attempted"}>Not Attempted</Option>
                          <Option value={"Yes"}>Yes</Option>
                          <Option value={"No"}>No</Option>
                        </Select>
                      </div>
                    </div>
                    <div className="col-6">
                      <label>Rotational Shift</label>
                      <div>
                        <Select
                          showSearch
                          mode="multiple"
                          getPopupContainer={(triggerNode) =>
                            triggerNode.parentElement
                          }
                          className="w-100 p-0 outline-none bg-white"
                          placeholder="Select Rotational Shift"
                          value={rotationalShift || null}
                          optionFilterProp="children"
                          filterOption={(input, option) => {
                            return (
                              option?.children
                                ?.toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0 ||
                              option.value
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            );
                          }}
                          onChange={(value) => {
                            clearPage();

                            if (isNavigateFromTrf) {
                              setTsNavigateFromTrf(false);
                              setSelectedDatevalue("Last 30 Days");
                              setDefaultDate(
                                handleFilterDateClicks("Last 30 Days"),
                              );
                            }
                            setRotationalShift([...value]);
                          }}
                        >
                          <Option value={"Not Attempted"}>Not Attempted</Option>
                          <Option value={"Yes"}>Yes</Option>
                          <Option value={"No"}>No</Option>
                        </Select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-2">
                      <label>TRF</label>
                      <div>
                        <Select
                          showSearch
                          getPopupContainer={(triggerNode) =>
                            triggerNode.parentElement
                          }
                          className="w-100 p-0 outline-none bg-white"
                          placeholder="Select TRF"
                          value={trfId || null}
                          optionFilterProp="children"
                          filterOption={(input, option) => {
                            return (
                              option?.children
                                ?.toLowerCase()
                                ?.indexOf(input.toLowerCase()) >= 0 ||
                              option.value
                                ?.toLowerCase()
                                ?.indexOf(input.toLowerCase()) >= 0
                            );
                          }}
                          onChange={(value) => {
                            clearPage();

                            if (isNavigateFromTrf) {
                              setTsNavigateFromTrf(false);
                              setSelectedDatevalue("Last 30 Days");
                              setDefaultDate(
                                handleFilterDateClicks("Last 30 Days"),
                              );
                            }
                            if (value === null) {
                              setTrfId("");
                              return;
                            }
                            setTrfId(value);
                          }}
                        >
                          <Option value={null}>All</Option>
                          {allTrfs?.map((trf) => (
                            <Option key={trf._id} value={trf._id}>{`${trf?.title}-${
                              trf?.department
                            }-${trf?.location}-${trf?.processName}-${moment(
                              trf?.tat,
                            )
                              .utc()
                              .format("YYYY-MM-DD")}${
                              trf?.workModal ? `-${trf.workModal}` : ""
                            }`}</Option>
                          ))}
                        </Select>
                      </div>
                    </div>
                    {headerFilterStatus !== "Application_Received" && (
                      <>
                        {/* <div className="col-md-6 mb-2">
                          <label>Interview Type</label>
                          <div>
                            <Select
                              showSearch
                              className="w-100 p-0 outline-none bg-white"
                              placeholder="Select Interview Type"
                              value={interviewType || null}
                              optionFilterProp="children"
                              filterOption={(input, option) => {
                                return (
                                  option?.children
                                    ?.toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0 ||
                                  option.value
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                );
                              }}
                              onChange={(value) => {
                                if (value === null) {
                                  setInterviewType("");
                                }
                                setCurrent(1);
                                setInterviewType(value);
                              }}
                            >
                              <Option value={null}>All</Option>
                              {interviewRouds?.map((interview, index) => {
                                return (
                                  <Option key={index} value={interview.value}>
                                    {interview.label}
                                  </Option>
                                );
                              })}
                            </Select>
                          </div>
                        </div> */}
                        <div className="col-md-6 mb-2">
                          <label>Recruiter</label>
                          <div>
                            <Select
                              showSearch
                              mode="multiple"
                              getPopupContainer={(triggerNode) =>
                                triggerNode.parentElement
                              }
                              className="w-100 p-0 outline-none bg-white"
                              placeholder="Select Recruiter"
                              value={recruiter || null}
                              optionFilterProp="children"
                              filterOption={(input, option) => {
                                return (
                                  option?.children
                                    ?.toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0 ||
                                  option.value
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                );
                              }}
                              onChange={(value) => {
                                clearPage();

                                if (isNavigateFromTrf) {
                                  setTsNavigateFromTrf(false);
                                  setSelectedDatevalue("Last 30 Days");
                                  setDefaultDate(
                                    handleFilterDateClicks("Last 30 Days"),
                                  );
                                }
                                setRecruiter([...value]);
                              }}
                            >
                               {users
                                ?.sort((a, b) =>
                                  a?.name
                                    ?.trim()
                                    .toLowerCase()
                                    .localeCompare(
                                      b?.name?.trim().toLowerCase(),
                                    ),
                                )
                                ?.map((user, index) => {
                                  if (user?.IsUserActive) {
                                    return (
                                      <Option key={index} value={user?._id}>
                                        {user?.name}
                                      </Option>
                                    );
                                  }
                                })}
                            </Select>
                          </div>
                        </div>
                      </>
                    )}
                    <div className="col-md-6 mb-2">
                      <label>Expected Versant</label>
                      <div>
                        <Select
                          showSearch
                          mode="multiple"
                          getPopupContainer={(triggerNode) =>
                            triggerNode.parentElement
                          }
                          className="w-100 p-0 outline-none bg-white"
                          placeholder="Select Versant Type"
                          value={versantScore || null}
                          optionFilterProp="children"
                          filterOption={(input, option) => {
                            const search = input.toLowerCase();
                            return (
                              String(option?.children ?? "")
                                .toLowerCase()
                                .includes(search) ||
                              String(option?.value ?? "")
                                .toLowerCase()
                                .includes(search)
                            );
                          }}
                          onChange={(value) => {
                            clearPage();

                            if (isNavigateFromTrf) {
                              setTsNavigateFromTrf(false);
                              setSelectedDatevalue("Last 30 Days");
                              setDefaultDate(
                                handleFilterDateClicks("Last 30 Days"),
                              );
                            }
                            setVersantScore([...value]);
                          }}
                        >
                          {["1", "2", "3", "4", "5", "6"]?.map(
                            (versant, index) => {
                              return (
                                <Option key={index} value={versant}>
                                  V{versant}
                                </Option>
                              );
                            },
                          )}
                        </Select>
                      </div>
                    </div>
                    <div className="col-md-6 mb-2">
                      <label>Qualification</label>
                      <div>
                        <Select
                          showSearch
                          mode="multiple"
                          getPopupContainer={(triggerNode) =>
                            triggerNode.parentElement
                          }
                          className="w-100 p-0 outline-none bg-white"
                          placeholder="Select Qualification"
                          value={qualification || null}
                          optionFilterProp="children"
                          filterOption={(input, option) => {
                            return (
                              option?.children
                                ?.toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0 ||
                              option.value
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            );
                          }}
                          onChange={(value) => {
                            clearPage();

                            if (isNavigateFromTrf) {
                              setTsNavigateFromTrf(false);
                              setSelectedDatevalue("Last 30 Days");
                              setDefaultDate(
                                handleFilterDateClicks("Last 30 Days"),
                              );
                            }
                            setQualification([...value]);
                          }}
                        >
                          {allQualification
                            ?.sort((a, b) =>
                              a
                                ?.trim()
                                .toLowerCase()
                                .localeCompare(b?.trim().toLowerCase()),
                            )
                            ?.map((qualification, index) => {
                              return (
                                <Option key={index} value={qualification}>
                                  {qualification}
                                </Option>
                              );
                            })}
                        </Select>
                      </div>
                    </div>
                    {isAmeyoActive && (
                    <div className="col-md-6 mb-2">
                      <label>Call Type</label>
                      <div>
                        <Select
                          allowClear
                          mode="multiple"
                          getPopupContainer={(triggerNode) =>
                            triggerNode.parentElement
                          }
                          className="w-100 p-0 outline-none bg-white"
                          placeholder="Select Call Type"
                          value={callType || []}
                          onChange={(value) => {
                            clearPage();
                            setCallType(value || []);
                          }}
                        >
                          <Option value="Call Me Now">Call Me Now</Option>
                          <Option value="1">Schedule Call 10:00 to 12:00</Option>
                          <Option value="2">Schedule Call 12:00 to 2:00</Option>
                          <Option value="3">Schedule Call 2:00 to 4:00</Option>
                          <Option value="4">Schedule Call 4:00 to 6:00</Option>
                          <Option value="5">Schedule Call 6:00 to 7:00</Option>
                        </Select>
                      </div>
                    </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mb-3 pb-4">
          <div className="col-12">
            <div
              className="pt-3 d-flex gap-1 justify-content-end"
              style={{ borderTop: "1px solid grey" }}
            >
              <button
                onClick={saveFilter}
                className="save-filter-btn text-black rounded px-4 py-2"
              >
                Save Filter
              </button>
              <button
                onClick={clearFilters}
                className="reset-filter-btn text-white border-0 rounded px-4 py-2"
              >
                Reset All
              </button>
              <button
                onClick={viewData}
                data-testid="add-new"
                className="btn btn-primary flex gap-[10px] items-center"
              >
                <span className="flex items-center text-[16px] font-semibold">
                  View Data
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export default AdvanceFilters;
